import { Values } from 'components/Wizards/MultiStepBlogPostWizard/Types'
import { reportError } from 'utils/error'
import { AiErrorModal } from 'components/AiErrorModal/AiErrorModal'
import { useModals } from 'almanac-ui/Modal'

type Mutation<T> = (values: Values) => Promise<T>

interface Props {
  onCancel?: () => void
}

export const useMutationWithErrorModal = <T,>(mutation: Mutation<T>, { onCancel }: Props) => {
  const { openModal, closeModal } = useModals()

  const generate = async (values: Values) => {
    try {
      await mutation(values)
    } catch (e) {
      reportError(e)
      openModal(AiErrorModal, {
        onCancel: () => {
          closeModal()
          onCancel?.()
        },
        onTryAgain: () => {
          closeModal()
          generate(values)
        },
      })
    }
  }

  return generate
}
